import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos de base de datos
export interface Database {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          cedula: string;
          email: string;
          full_name: string;
          role: 'user' | 'admin';
          is_active: boolean;
          is_banned: boolean;
          balance: number;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['users']['Row'], 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Database['public']['Tables']['users']['Insert']>;
      };
      cards: {
        Row: {
          id: string;
          user_id: string;
          card_number: string;
          holder_name: string;
          expiry_date: string;
          cvv: string;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['cards']['Row'], 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Database['public']['Tables']['cards']['Insert']>;
      };
      transactions: {
        Row: {
          id: string;
          user_id: string;
          amount: number;
          type: 'deposit' | 'withdrawal' | 'payment' | 'transfer';
          description: string | null;
          merchant_id: number | null;
          status: 'pending' | 'approved' | 'rejected';
          created_at: string;
        };
        Insert: Omit<Database['public']['Tables']['transactions']['Row'], 'id' | 'created_at'>;
        Update: Partial<Database['public']['Tables']['transactions']['Insert']>;
      };
      withdrawal_requests: {
        Row: {
          id: string;
          user_id: string;
          amount: number;
          account_type: string;
          holder_name: string;
          holder_cedula: string;
          account_number: string;
          description: string | null;
          status: 'pending' | 'approved' | 'rejected';
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['withdrawal_requests']['Row'], 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Database['public']['Tables']['withdrawal_requests']['Insert']>;
      };
      deposit_requests: {
        Row: {
          id: string;
          user_id: string;
          amount: number;
          receipt_url: string;
          note: string | null;
          status: 'pending' | 'approved' | 'rejected';
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['deposit_requests']['Row'], 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Database['public']['Tables']['deposit_requests']['Insert']>;
      };
      tickets: {
        Row: {
          id: string;
          user_id: string;
          subject: 'transferencia' | 'deposito' | 'retiro' | 'otro';
          message: string | null;
          status: 'open' | 'in_progress' | 'resolved' | 'closed';
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['tickets']['Row'], 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Database['public']['Tables']['tickets']['Insert']>;
      };
      loan_requests: {
        Row: {
          id: string;
          user_id: string;
          amount: number;
          purpose: string;
          monthly_income: number;
          employment_status: string;
          status: 'pending' | 'approved' | 'rejected';
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['loan_requests']['Row'], 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Database['public']['Tables']['loan_requests']['Insert']>;
      };
      merchants: {
        Row: {
          id: number;
          name: string;
          label: string;
          logo: string;
          created_at: string;
        };
        Insert: Omit<Database['public']['Tables']['merchants']['Row'], 'id' | 'created_at'>;
        Update: Partial<Database['public']['Tables']['merchants']['Insert']>;
      };
      admin_logs: {
        Row: {
          id: string;
          admin_email: string;
          action: string;
          details: string | null;
          timestamp: string;
        };
        Insert: Omit<Database['public']['Tables']['admin_logs']['Row'], 'id' | 'timestamp'>;
        Update: Partial<Database['public']['Tables']['admin_logs']['Insert']>;
      };
    };
  };
}
